module.exports = __webpack_public_path__ + "img/like-icon.cf44c772.svg";